import type { Drill } from "@/domain/learning/model/drill";
import type { Level } from "@/domain/learning/model/level";
import { presentDrillForPhase, skillKeyOf } from "@/domain/learning/retention-schedule";
import { dueSkillKeys, type SkillMemory } from "@/domain/learning/skill-memory";

/** 1回の復習セッションで出す上限。短時間で想起を回し、疲労を避ける。 */
export const MAX_REVIEW_DRILLS = 8;

/**
 * 期限到来スキルごとに、想起相の演習を1問選ぶ（F-011）。
 * 同じスキルの習得相（先頭2問）は避け、variant の後半を優先する。
 */
export function buildReviewPlaylist(
  levels: readonly Level[],
  memory: SkillMemory,
  nowMs: number = Date.now(),
): readonly Drill[] {
  const due = dueSkillKeys(memory, nowMs);
  if (due.length === 0) {
    return [];
  }

  const bySkill = new Map<string, Drill[]>();
  for (const level of levels) {
    for (const lesson of level.lessons) {
      for (const drill of lesson.drills) {
        const key = skillKeyOf(drill);
        if (key === null) {
          continue;
        }
        const bucket = bySkill.get(key);
        if (bucket === undefined) {
          bySkill.set(key, [drill]);
        } else {
          bucket.push(drill);
        }
      }
    }
  }

  const playlist: Drill[] = [];
  for (const skill of due) {
    if (playlist.length >= MAX_REVIEW_DRILLS) {
      break;
    }
    const candidates = bySkill.get(skill);
    if (candidates === undefined || candidates.length === 0) {
      continue;
    }
    // 末尾の variant を想起向きとして優先する。
    const pick = candidates[candidates.length - 1];
    if (pick !== undefined) {
      playlist.push(presentDrillForPhase(pick, "retrieval"));
    }
  }
  return playlist;
}
